// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_5bc750', '__Inter_Fallback_5bc750'","fontStyle":"normal"},"className":"__className_5bc750","variable":"__variable_5bc750"};